// extracted by mini-css-extract-plugin
export default {"privacy_policy":"PrivacyPolicy_privacy_policy__RtRrp","privacy_policy_header":"PrivacyPolicy_privacy_policy_header__skIj1"};